import { Pipe, PipeTransform } from '@angular/core';
import { Country } from '../enums/countries.enum';

@Pipe({ name: 'getFlag' })
export class GetFlagPipe implements PipeTransform {
  transform(country: string): string {
    if (country) {
      const countrySlug = country.replace(/ /g, '');
      const countryCode = Country[countrySlug] !== undefined ? Country[countrySlug] : 'GR';
      const countryCodeLowerCase = countryCode.toLowerCase();
      return 'assets/media/flags/' + countryCodeLowerCase + '.svg';
    }
  }
}
